module.exports = __webpack_public_path__ + "static/media/nota-icon.cccc94df.svg";